import { LogoInline } from "../common/Conf"

interface Props {
    instanceCode: string
}

export default function HeaderPage(props: Props) {
    return <header style={{ flex: 1, paddingLeft: '40px', paddingRight: '40px', paddingTop:0 }}>
        <img className="header-logo pointer" alt="" data-code="home" src={LogoInline(props.instanceCode)} />
    </header>
}
//`/${LocationGroup}/svg/logo-inline-header.svg`